var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"page-content"},[_c('b-col',{attrs:{"cols":"12"}},[_c('keywords-table')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }